import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    items: [
      {
        name: 'entity',
        prevpage: 1
      },
      {
        name: 'house',
        prevpage: 1
      },
      {
        name: 'brand',
        prevpage: 1
      },
      {
        name: 'division',
        prevpage: 1
      },
      {
        name: 'department',
        prevpage: 1
      },
      {
        name: 'stage',
        prevpage: 1
      },
      {
        name: 'productHierarchy',
        prevpage: 1
      },
      {
        name: 'costCenter',
        prevpage: 1
      },
      {
        name: 'costCategory',
        prevpage: 1
      },
      {
        name: 'costElement',
        prevpage: 1
      },
      {
        name: 'costConsumer',
        prevpage: 1
      },
      {
        name: 'taxonomy',
        prevpage: 1
      },
      {
        name: 'user',
        prevpage: 1
      },
      {
        name: 'profile',
        prevpage: 1
      },
      {
        name: 'sshcp_regions',
        prevpage: 1
      },
      {
        name: 'master-regions',
        prevpage: 1
      },
      {
        name: 'sshcp_districts',
        prevpage: 1
      },
      {
        name: 'master-districts',
        prevpage: 1
      },
      {
        name: 'master-vendors',
        prevpage: 1
      },
      {
        name: 'master-groups',
        prevpage: 1
      },
      {
        name: 'master-activities',
        prevpage: 1
      },
      {
        name: 'sshcp_budget_mapping',
        prevpage: 1
      },
      {
        name: 'sshcp_user_mapping',
        prevpage: 1
      },
      {
        name: 'sshcp_approval_mapping',
        prevpage: 1
      }
    ]
  },
  mutations: {
    [mutations.SET_PREV_PAGE](state, payload) {
      let name = state.items.find(item => item.name === payload.name);
      if (name) {
        name.prevpage = payload.prevpage;
      }
    },
    [mutations.RESET_PREV_PAGE](state) {
      state.items = state.items.map(item => {
        item.prevpage = 1;
        return item;
      });
    },
    [mutations.SET_PREV_PERPAGE](state, payload) {
      let name = state.items.find(item => item.name === payload.name);
      if (name) {
        name.prevPerPage = payload.prevPerPage;
      }
    },
    [mutations.RESET_PREV_PERPAGE](state) {
      state.items = state.items.map(item => {
        item.prevPerPage = 10;
        return item;
      });
    }
  },
  actions: {},
  getters: {}
};
